
export default {
	async newGlobalPost(context, payload) {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		const firstName = localStorage.getItem('firstName');
		const lastName = localStorage.getItem('lastName');
		const team = localStorage.getItem('team');
		const userLeague = localStorage.getItem('league');
		const post = {
			byUserId: userId,
			byUser: firstName + ' ' + lastName,
			byUserTeam: team,
			byUserLeague: userLeague,
			title: payload.title,
			message: payload.message,
			timeStamp: payload.timeStamp,
			likes: 0,
			dislikes: 0,
			likedBy: ['1'],
			dislikedBy: ['1'],
			viewedBy: ['1'],
		};
		const response = await fetch(`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/global.json?auth=` + token, {
			method: 'POST',
			body: JSON.stringify(post),
		});
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		context.commit('addGlobalPosts', post);
	},
	async globalPostLike(context, payload) {
		const token = localStorage.getItem('token');
		const idPost = payload.id;
		const post = {
			likes: payload.likes,
			dislikes: payload.dislikes,
			likedBy: payload.likedBy,
			dislikedBy: payload.dislikedBy,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/global/${idPost}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async globalPostDisLike(context, payload) {
		const token = localStorage.getItem('token');
		const idPost = payload.id;
		const post = {
			dislikes: payload.dislikes,
			likes: payload.likes,
			dislikedBy: payload.dislikedBy,
			likedBy: payload.likedBy,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/global/${idPost}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async deleteGlobalPost(context, payload) {
		const token = localStorage.getItem('token');
		const postId = payload.id;
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/global/${postId}.json?auth=` + token,
			{
				method: 'DELETE',
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		context.commit('deletedGlobalPost', postId);
	},
	async fetchGlobalPosts(context) {
		const token = localStorage.getItem('token');
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/global.json?auth=` + token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const posts = [];
		const rLikedBy = [];
		const rDislikedBy = [];

		for (const key in responseData) {
			const post = {
				id: key,
				byUserId: responseData[key].byUserId,
				byUser: responseData[key].byUser,
				byUserTeam: responseData[key].byUserTeam,
				byUserLeague: responseData[key].byUserLeague,
				title: responseData[key].title,
				message: responseData[key].message,
				timeStamp: responseData[key].timeStamp,
				likes: responseData[key].likes,
				dislikes: responseData[key].dislikes,
				dislikedBy: responseData[key].dislikedBy,
				likedBy: responseData[key].likedBy,
				viewedBy: responseData[key].viewedBy
			};
			// for (const idLikedBy in responseData[key].likedBy) {
			// 	rLikedBy.push(responseData[key].likedBy[idLikedBy]);
			// }
			// for (const idDislikedBy in responseData[key].dislikedBy) {
			// 	rDislikedBy.push(responseData[key].dislikedBy[idDislikedBy]);
			// }
			posts.push(post);
		}
		context.commit('setGlobalPosts', posts);
	},
	async newLeaguePost(context, payload) {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		const firstName = localStorage.getItem('firstName');
		const lastName = localStorage.getItem('lastName');
		const team = localStorage.getItem('team');
		const league = localStorage.getItem('league');
		const division = localStorage.getItem('division');
		const userType = localStorage.getItem('userType')
		const post = {
			byUserId: userId,
			byUser: firstName + ' ' + lastName,
			byUserTeam: team,
			byUserLeague: league,
			byUserDivision: division,
			byUserType: userType,
			title: payload.title,
			message: payload.message,
			commentCount: payload.commentCount,
			timeStamp: payload.timeStamp,
			likes: 0,
			dislikes: 0,
			likedBy: ['1'],
			dislikedBy: ['1'],
			viewedBy: ['1'],
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}.json?auth=` + token,
			{
				method: 'POST',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		context.commit('addLeaguePosts', post);
	},
	async leaguePostCommentCount(context, payload) {
		const token = localStorage.getItem('token');
		const postId = payload.postId;
		const team = localStorage.getItem('team');
		const league = localStorage.getItem('league');
		const post = {
			commentCount: payload.commentCount,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}/${postId}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		// context.commit('addTeamPosts', post);
	},
	async leaguePostLike(context, payload) {
		const token = localStorage.getItem('token');
		const idPost = payload.id;
		const league = localStorage.getItem('league');
		const post = {
			likes: payload.likes,
			dislikes: payload.dislikes,
			likedBy: payload.likedBy,
			dislikedBy: payload.dislikedBy,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}/${idPost}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async leaguePostDisLike(context, payload) {
		const token = localStorage.getItem('token');
		const idPost = payload.id;
		const league = localStorage.getItem('league');
		const post = {
			dislikes: payload.dislikes,
			likes: payload.likes,
			dislikedBy: payload.dislikedBy,
			likedBy: payload.likedBy,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}/${idPost}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async newLeagueComment(context, payload) {
		const token = localStorage.getItem('token');
		const postId = payload.postId;
		const userId = localStorage.getItem('userId');
		const firstName = localStorage.getItem('firstName');
		const lastName = localStorage.getItem('lastName');
		const team = localStorage.getItem('team');
		const league = localStorage.getItem('league');
		const userType = localStorage.getItem('userType')
		const comment = {
			commentBody: payload.commentBody,
			byUserId: userId,
			byUser: firstName + ' ' + lastName,
			byUserTeam: team,
			byUserLeague: league,
			byUserType: userType,
			timeStamp: payload.timeStamp,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}/${postId}/comments.json?auth=` +
				token,
			{
				method: 'POST',
				body: JSON.stringify(comment),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async deleteLeaguePost(context, payload) {
		const token = localStorage.getItem('token');
		const league = localStorage.getItem('league');
		const postId = payload.id;
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}/${postId}.json?auth=` + token,
			{
				method: 'DELETE',
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		context.commit('deletedLeaguePost', postId);
	},
	async fetchLeaguePosts(context) {
		const token = localStorage.getItem('token');
		const league = localStorage.getItem('league');
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}.json?auth=` + token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const posts = [];
		const rLikedBy = [];
		const rDislikedBy = [];

		for (const key in responseData) {
			const post = {
				id: key,
				byUserId: responseData[key].byUserId,
				byUser: responseData[key].byUser,
				byUserTeam: responseData[key].byUserTeam,
				byUserLeague: responseData[key].byUserLeague,
				byUserDivision: responseData[key].byUserDivision,
				byUserType: responseData[key].byUserType,
				title: responseData[key].title,
				message: responseData[key].message,
				timeStamp: responseData[key].timeStamp,
				comments: responseData[key].comments,
				commentCount: responseData[key].commentCount,
				likes: responseData[key].likes,
				dislikes: responseData[key].dislikes,
				dislikedBy: responseData[key].dislikedBy,
				likedBy: responseData[key].likedBy,
				viewedBy: responseData[key].viewedBy,
			};
			// for (const idLikedBy in responseData[key].likedBy) {
			// 	rLikedBy.push(responseData[key].likedBy[idLikedBy]);
			// }
			// for (const idDislikedBy in responseData[key].dislikedBy) {
			// 	rDislikedBy.push(responseData[key].dislikedBy[idDislikedBy]);
			// }
			posts.push(post);
		}
		context.commit('setLeaguePosts', posts);
	},
	async newTeamPost(context, payload) {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		const firstName = localStorage.getItem('firstName');
		const lastName = localStorage.getItem('lastName');
		const team = localStorage.getItem('team');
		const league = localStorage.getItem('league');
		const userType = localStorage.getItem('userType');
		const post = {
			byUserId: userId,
			byUser: firstName + ' ' + lastName,
			byUserTeam: team,
			byUserLeague: league,
			userType: userType,
			title: payload.title,
			message: payload.message,
			commentCount: payload.commentCount,
			timeStamp: payload.timeStamp,
			likes: 0,
			dislikes: 0,
			likedBy: ['1'],
			dislikedBy: ['1'],
			viewedBy: ['1'],
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}.json?auth=` + token,
			{
				method: 'POST',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		context.commit('addTeamPosts', post);
	},
	async teamPostCommentCount(context, payload) {
		const token = localStorage.getItem('token');
		const postId = payload.postId;
		const team = localStorage.getItem('team');
		const league = localStorage.getItem('league');
		const post = {
			commentCount: payload.commentCount,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}/${postId}.json?auth=` +
				token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		// context.commit('addTeamPosts', post);
	},
	async teamPostLike(context, payload) {
		const token = localStorage.getItem('token');
		const idPost = payload.id;
		const league = localStorage.getItem('league');
		const team = localStorage.getItem('team');

		const post = {
			likes: payload.likes,
			dislikes: payload.dislikes,
			likedBy: payload.likedBy,
			dislikedBy: payload.dislikedBy,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}/${idPost}.json?auth=` +
				token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async teamPostDisLike(context, payload) {
		const token = localStorage.getItem('token');
		const idPost = payload.id;
		const league = localStorage.getItem('league');
		const team = localStorage.getItem('team');

		const post = {
			dislikes: payload.dislikes,
			likes: payload.likes,
			dislikedBy: payload.dislikedBy,
			likedBy: payload.likedBy,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}/${idPost}.json?auth=` +
				token,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async newTeamComment(context, payload) {
		const token = localStorage.getItem('token');
		const postId = payload.postId;
		const userId = localStorage.getItem('userId');
		const firstName = localStorage.getItem('firstName');
		const lastName = localStorage.getItem('lastName');
		const team = localStorage.getItem('team');
		const league = localStorage.getItem('league');
		const userType = localStorage.getItem('userType');
		const comment = {
			commentBody: payload.commentBody,
			byUserId: userId,
			byUser: firstName + ' ' + lastName,
			byUserTeam: team,
			byUserLeague: league,
			userType: userType,
			timeStamp: payload.timeStamp,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}/${postId}/comments.json?auth=` +
				token,
			{
				method: 'POST',
				body: JSON.stringify(comment),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async deleteTeamPost(context, payload) {
		const token = localStorage.getItem('token');
		const league = localStorage.getItem('league');
		const team = localStorage.getItem('team');

		const postId = payload.id;
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}/${postId}.json?auth=` +
				token,
			{
				method: 'DELETE',
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		context.commit('deletedTeamPost', postId);
	},
	async fetchTeamPosts(context) {
		const token = localStorage.getItem('token');
		const league = localStorage.getItem('league');
		const team = localStorage.getItem('team');

		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}.json?auth=` + token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const posts = [];
		const rLikedBy = [];
		const rDislikedBy = [];

		for (const key in responseData) {
			const post = {
				id: key,
				byUserId: responseData[key].byUserId,
				byUser: responseData[key].byUser,
				byUserTeam: responseData[key].byUserTeam,
				byUserLeague: responseData[key].byUserLeague,
				byUserType: responseData[key].byUserType,
				title: responseData[key].title,
				message: responseData[key].message,
				timeStamp: responseData[key].timeStamp,
				comments: responseData[key].comments,
				commentCount: responseData[key].commentCount,
				likes: responseData[key].likes,
				dislikes: responseData[key].dislikes,
				dislikedBy: responseData[key].dislikedBy,
				likedBy: responseData[key].likedBy,
			};
			// for (const idLikedBy in responseData[key].likedBy) {
			// 	rLikedBy.push(responseData[key].likedBy[idLikedBy]);
			// }
			// for (const idDislikedBy in responseData[key].dislikedBy) {
			// 	rDislikedBy.push(responseData[key].dislikedBy[idDislikedBy]);
			// }
			posts.push(post);
		}
		context.commit('setTeamPosts', posts);
	},
};